import request from '@/utils/request'

/**
 * 查询店铺入驻小区列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function getShopCommunityList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.queryShopCommunity',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 审核店铺入驻小区
 * @param {Object} data 审核数据
 * @returns {Promise} Promise对象
 */
export function auditShopCommunity(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.auditShopCommunity',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code != 0) {
        reject(res.msg)
        return
      }
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}